import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiMapPin, FiDollarSign } = FiIcons;

const TrustSection = () => {
  const recentExits = [
    {
      company: "HVAC Shop",
      amount: "$17.2M",
      location: "Texas",
      description: "Full-service HVAC contractor with commercial and residential divisions"
    },
    {
      company: "HVAC",
      amount: "$3.4M",
      location: "Arizona",
      description: "Residential HVAC service and installation company"
    },
    {
      company: "Comfort Solutions HVAC",
      amount: "$8.7M",
      location: "Florida",
      description: "Commercial HVAC specialist with maintenance contracts"
    },
    {
      company: "Elite Heating & Cooling",
      amount: "$12.1M",
      location: "Georgia",
      description: "Multi-location HVAC service provider"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Recent Exits
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our track record speaks for itself. We've successfully guided HVAC business 
            owners through profitable exits across the country.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {recentExits.map((exit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-gray-50 rounded-lg p-6 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <SafeIcon icon={FiCheckCircle} className="w-6 h-6 text-green-500" />
                <span className="text-sm text-gray-500">SOLD</span>
              </div>
              
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {exit.company}
              </h3>
              
              <div className="flex items-center space-x-2 mb-2">
                <SafeIcon icon={FiDollarSign} className="w-4 h-4 text-blue-600" />
                <span className="text-2xl font-bold text-blue-600">{exit.amount}</span>
                <span className="text-sm text-gray-500">Sale</span>
              </div>
              
              <div className="flex items-center space-x-2 mb-3">
                <SafeIcon icon={FiMapPin} className="w-4 h-4 text-gray-500" />
                <span className="text-sm text-gray-600">{exit.location}</span>
              </div>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {exit.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <div className="bg-blue-50 rounded-lg p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
              Ready to Join Our Success Stories?
            </h3>
            <p className="text-gray-600 mb-6">
              Let us help you achieve a successful exit and maximize your company's value.
            </p>
            <button
              onClick={() => document.getElementById('valuation')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-300"
            >
              Start Your Valuation
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustSection;